<template lang="pug">
  .component-translation-edit
    .row.column.card.pt-2
      h3.text-center {{body.group}}.{{body.key}}
      template(v-if="allowedLanguages.length")
        .row
          .column
            label lang
          .column
            label value
        .row(v-for="(key) in allowedLanguages")
          .column.small-2.large-1.medium-1
            input(type="text", :value="key" readonly='readOnly')
          .column
            Editor(v-if="editor", v-model="typeof body.value[key] === 'object'? JSON.stringify(body.value[key]) : body.value[key]", :disabled="!item.editable && !editableKeys.includes(key)")
            textarea(v-else, v-model="typeof body.value[key] === 'object'? JSON.stringify(body.value[key]) : body.value[key]" :name='key' rows="8", :disabled="!item.editable && !editableKeys.includes(key)")
        .row
          .column
            ActionButton(:action="update") Update
          .column.text-right
            TranslationButtons(:item="item", v-if="deleteButton" )
      template(v-else)
        h2.text-center Missing allowedLanguages configuration

</template>

<script>
import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
import MaggieHelper from "../../maggieHelper";
import ActionButton from "../../components/structure/ui/ActionButton";
import LoadingSpinner from "../../components/structure/LoadingSpinner";
import {mapState} from "vuex";
import collect from "collect.js";
import TransactionActionButtons from "../../components/structure/ui/actions/TransactionButtons.vue";
import TranslationButtons from "../../components/structure/ui/actions/TranslationButtons.vue";
import Editor from "../../components/structure/ui/Editor.vue";


export default {
  name: 'TranslationEdit',
  components: {Editor, TranslationButtons, TransactionActionButtons, LoadingSpinner, ActionButton},
  data() {
    return {
      bodyDefault: {
        group: '',
        key: '',
        value: [],
      },
      otherValues: {
        value: [],
      },
      existingKeys: []
    }
  },
  created() {
    this.existingKeys = Object.keys(this.item.value)
  },
  methods: {
    sanitazeNullValues(obj) {
      for (const key in obj) {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      }
    },
    update() {
      this.body.group.trim()
      this.body.key.trim()
      Object.assign(this.body.value, this.otherValues.value)
      this.sanitazeNullValues(this.body.value)
      this.body.editable = this.editable
      if (this.item.id !== undefined) {
        return KeplerBackofficeSdk.translations.select(this.item.id).update(this.body, (data) => {
          MaggieHelper.notification('Done', 'Translation Updated')
        })
      } else {
        return KeplerBackofficeSdk.translations.make(this.body, (data) => {
          MaggieHelper.notification('Done', 'Translation created')
        })
      }
    }
  },
  computed: {
    body: {
      get: function () {
        this.bodyDefault.group = this.item.group
        this.bodyDefault.key = this.item.key
        this.sanitazeNullValues(this.item.value)
        this.bodyDefault.value = this.item.value
        return this.bodyDefault
      },
      set: function (item) {

        this.bodyDefault.group = item.group
        this.bodyDefault.key = item.key
        this.sanitazeNullValues(item.value)
        this.bodyDefault.value = item.value
      }
    },

    ...mapState({
      configuration: state => state.configuration,
    }),
    allowedLanguages() {
      const systemFields = collect(this.configuration.system.system_fields_configuration.value);
      const defaultLang = this.configuration.application.application_default_language.value
      let config = systemFields.first((i) => i.field === 'allowedLanguages');
      if (config.config === null) {
        return []
      }
      if (config.field === 'allowedLanguages') {
        let allowedLanguages = collect(this.configuration.system.system_fields_configuration.value).first((i) => i.field === 'allowedLanguages').config.split(',')
        if (this.skipDefaultLang) {
          allowedLanguages = allowedLanguages.filter((lang) => {
            return lang !== defaultLang
          })
        }
        return allowedLanguages
      } else {
        return []
      }
    },
    editableKeys() {
      if (this.item.editable) {
        return this.allowedLanguages
      }

      return this.allowedLanguages.filter((k) => {
        return !this.existingKeys.includes(k)
      })
    },
  },
  props: {
    item: {
      type: Object
    },
    deleteButton: {
      type: Boolean
    },
    editor: {
      type: Boolean,
    },
    skipDefaultLang: {
      type: Boolean,
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
}
</script>

<style>


</style>



// WEBPACK FOOTER //
// TranslationEdit.vue?10fb5aae